/**
 * AB实验统一管理
 * 用于管理项目中所有的AB实验变量
 *
 * @example
 * const AB_HOT_WORD = {
 *   variableName: "hot_word",
 *   defaultValue: "string_0",
 *   map: {
 *     old: ["string_0", "string_2"],
 *     new: "string_1",
 *   },
 * };
 * const abTest = useABTest(AB_HOT_WORD);
 * // 返回 {loading: false, value: "old", old: true, new: false}
 */

// ==================== 正在运行的实验 ====================
/**
 * 搜索结果页左侧筛选面板实验

 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5065
 * 实验变量： hb_search_filter_panel
 * 实验值：
 *  - old: 旧版筛选面板
 *  - new: 新版筛选面板
 *
 * 实验逻辑：
 *  - 控制搜索结果页左侧筛选面板的展示方式
 */
export const AB_SEARCH_FILTER_PANEL = {
  variableName: "hb_search_filter_panel",
  defaultValue: "new",
  map: {
    old: "old",
    new: "new",
  },
};

/**
 * @deprecated 已下线
 * 搜索tab文本实验:商用素材与源文件文案实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=4380
 * 实验变量： hb_search_tab_text
 * 实验值：
 *  - text_1: 文本1
 *  - text_2: 文本2
 *
 * 实验逻辑：
 *  - 控制搜索tab的文本显示
 */
export const AB_SEARCH_TAB_TEXT = {
  variableName: "hb_search_tab_text",
  defaultValue: "text_1",
  map: {
    planA: "text_1",
    planB: "text_2",
  },
};

/**
 * @deprecated 已下线
 * 素材详情页信息展示实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=4616
 * 实验变量： hb_detail_material_info
 * 实验值：
 *  - old: 旧版信息展示
 *  - new: 新版信息展示
 *
 * 实验逻辑：
 *  - 控制素材详情页信息的展示方式
 */
export const AB_DETAIL_MATERIAL_INFO = {
  variableName: "hb_detail_material_info",
  defaultValue: "old",
  map: {
    old: "old",
    new: "new",
  },
};

/**
 * AI工具入口跳转至art
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5099
 * 实验变量： AI_Redirect_path
 * 实验值：
 *  - string_2: 跳转到art站点
 *  - 其他: 跳转到默认站点
 *
 * 实验逻辑：
 *  - 控制AI工具入口的跳转路径
 */
export const AB_AI_REDIRECT_PATH = {
  variableName: "AI_Redirect_path",
  defaultValue: "string_0",
};

/**
 * 画板推荐模块实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5164
 * 实验变量： art_recommend_board_list
 * 实验值：
 *  - old: 旧版推荐模块
 *  - new: 新版推荐模块
 */
export const AB_ART_RECOMMEND_BOARD_LIST = {
  variableName: "art_recommend_board_list",
  defaultValue: "old",
};

/**
 * 搜索结果页-推荐搜索词实验

 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5168
 * 实验变量： search_feed_words
 * 实验值：
 *  - string_0: 原始组 无推荐搜索词
 *  - string_1: 实验组 有推荐搜索词
 *  - string_2: 对照组 无推荐搜索词
 *  - string_3: 实验组 有推荐搜索词
 *  - string_4: 对照组 有推荐搜索词
 *
 * 实验逻辑：
 *  - 控制采集详情页推荐模块的优化策略
 */
export const AB_SEARCH_FEED_WORDS = {
  variableName: "search_feed_words",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1", "string_3", "string_4"],
  },
};

export const AB_PIN_DETAIL_AIGAMEPLAY = {
  variableName: "hb_pindetail_aigameplay",
  defaultValue: "show",
  map: {
    show: ["show"],
    hide: ["hide"],
  },
};

/**
 * 花瓣全屏采集详情页
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5191
 * 实验变量： hb_pindetail_feed
 * 实验值：
 *  - old: 原始组 & 对照组
 *  - feed: 实验组
 */
export const AB_PIN_DETAIL_FULLSCREEN = {
  variableName: "hb_pindetail_feed",
  defaultValue: "old",
  map: {
    old: "old",
    newFull: ["feed", "string_3"],
  },
};

/**
 * 用户信息统一与管理
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5208
 * 实验变量： userinfo_settings
 * 实验值：
 *  - string_0: 原始版本
 *  - string_1: 实验版本
 *  - string_2: 对照组
 *
 * 实验逻辑：
 *  - 控制用户信息统一与管理
 */
export const AB_USERINFO_SET = {
  variableName: "userinfo_settings",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1"],
  },
};

/**
 * 详情页为你推荐插入词和主题
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5202
 * 实验变量： hb_pin_word_topic
 * 实验值：
 *  - string_0: 原始组
 *  - string_1: 实验组
 *  - string_2: 对照组
 */
export const AB_PIN_WORD_TOPIC = {
  variableName: "hb_pin_word_topic",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1"],
  },
};

/**
 * 多人画板功能实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5203
 * 实验变量： hb_multi_board
 * 实验值：
 *  - string_0: 原始组
 *  - string_1: 实验组
 *  - string_2: 对照组
 *
 * 实验逻辑：
 *  - 控制多人画板的展示方式
 */
export const AB_MULTI_BOARD = {
  variableName: "hb_multi_board",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: "string_1",
  },
};

/**
 *  @deprecated 已下线
 * 画板推荐模块实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5221
 * 实验变量： hb_recommend_create_board
 * 实验值：
 *  - string_0: 原始版本
 *  - string_1: 实验组1
 *  - string_2: 实验组2
 */
export const AB_RECOMMEND_CREATE_BOARD = {
  variableName: "hb_recommend_create_board",
  defaultValue: "string_1",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1"],
  },
};

/**
 * 搜索推荐统一AB实验
 * 实验地址：[待补充实验平台地址]
 * 实验变量： search_rec_unified
 * 实验值：
 *  - string_0: 原始组（都不展示）
 *  - string_1: 灵感词组（只展示灵感推荐词）
 *  - string_2: 底纹词组（只展示推荐底纹词）
 *  - string_3: 顶部标签组（只展示搜索推荐词标签）
 *  - string_4: 对照组（都不展示）
 *
 * 实验逻辑：
 *  - 三个功能互斥，同一时刻只能展示一个
 *  - 灵感词：控制整个功能开关
 *  - 底纹词：只控制推荐词接口，运营词继续请求
 *  - 顶部标签：控制接口调用和扩展埋点字段上报
 */
export const AB_WORD_REAL_HISTORY = {
  variableName: "word_real_history",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_4"],
    inspirationWords: "string_1",
    placeholder: "string_2",
    recommendTags: "string_3",
  },
};

/**
 * 创意扩展实验AB, 用于控制创意扩展功能的展示
 */
export const AB_CREATIVE_EXTENSION = {
  variableName: "creative_remix",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "old"],
    new: "new",
  },
};

/**
 * 采集卡片放大镜功能实验
 *
 * 实验地址：[待填写]
 * 实验变量：hb_pin_card_magnifier
 * 实验值：
 *  - string_0: 原始版本（不显示放大镜）
 *  - string_1: 实验组1（只开启放大镜功能，不改变列数）
 *  - string_2: 对照组（不显示放大镜）
 *  - string_3: 实验组2（开启放大镜功能，列数+1）
 *
 * 实验逻辑：
 *  - 控制采集卡片hover时是否显示放大镜图标
 *  - 鼠标hover放大镜图标时弹出大图预览浮窗
 *  - string_1: 只开启放大镜功能，不改变列数
 *  - string_3: 开启放大镜功能，列数+1
 */
export const AB_PIN_CARD_MAGNIFIER = {
  variableName: "hb_pin_card_magnifier",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_2"],
    new: ["string_1", "string_3"],
  },
};

/**
 * 采集详情页找相似按钮实验
 * 实验变量： pin_similar
 * 实验值：
 *  - string_0: 原始版本（旧按钮）
 *  - string_1: 实验组（新按钮）
 *  - string_2: 对照组（旧按钮）
 */
export const AB_PIN_SIMILAR = {
  variableName: "pin_similar",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_2"],
    new: "string_1",
  },
};

/**
 * 未整理采集链路优化实验
 * 实验变量： hb_savetounsort
 * 实验值：
 *  - string_0: 原始版本（使用 getRelatedBoards）
 *  - old: 对照组（使用 getRelatedBoards）
 *  - new: 实验组（使用 getRelatedBoardsWeb）
 *
 * 实验逻辑：
 *  - 控制推荐画板接口的选择
 *  - 实验组 new 使用新接口 getRelatedBoardsWeb
 *  - 对照组 old 和原始版本 string_0 使用旧接口 getRelatedBoards
 */
export const AB_SAVE_TO_UNSORT = {
  variableName: "hb_savetounsort",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "old"],
    new: "new",
  },
};

/**
 * 图搜页面布局实验
 * 实验地址：https://data.gaoding.com/index.html#/abtest/application/expList/view?expId=5327&tab=settings&version=domestic
 * 实验变量： image_search_scroll
 * 实验值：
 *  - string_0: 原始组（左右分栏，左侧固定）
 *  - string_1: 实验组（原图下方展示瀑布流，整体滚动）
 *  - string_2: 对照组
 *
 * 实验逻辑：
 *  - 对照组：左右分栏布局，左侧原图 sticky 固定
 *  - 实验组：去除左侧 sticky，原图下方也展示瀑布流，整体页面滚动
 */
export const AB_SIMILAR_PAGE_LAYOUT = {
  variableName: "image_search_scroll",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_2"],
    new: "string_1",
  },
};

/**
 * 搜索结果页渐进式搜索实验
 * 实验变量： hb_feedback_search
 * 实验值：
 *  - string_0: 对照组（旧版）
 *  - string_1: 实验组（新版渐进式搜索）
 *  - string_2: 对照组（旧版）
 *
 * 实验逻辑：
 *  - 控制搜索结果页是否显示渐进式搜索功能
 *  - 实验组：卡片"更多"菜单添加"喜欢"/"不喜欢"选项，支持反馈搜索
 */
export const AB_FEEDBACK_SEARCH = {
  variableName: "hb_feedback_search",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_2"],
    new: "string_1",
  },
};

/**
 * 推荐画板实验
 * 实验变量：board_recommend
 * 实验值：
 *  - string_0: 原始版本（不显示相似画板）
 *  - string_1: 实验组（显示相似画板）
 *  - string_2: 对照组（显示相似画板）
 *
 * 实验逻辑：
 *  - 控制是否显示相似画板功能
 */
export const AB_SIMILAR_BOARD_RECOMMEND = {
  variableName: "board_recommend",
  defaultValue: "string_0",
  map: {
    old: ["string_0", "string_2"],
    new: "string_1",
  },
};
